import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

export const useLocationState = () => {
	return useSelector((state) => state?.location);
};

export const initialState = {};

export const locationSlice = createSlice({
	name: 'location',
	initialState,
	reducers: {
		setLocation(state, action) {
			return {
				...state,
				...action.payload
			};
		}
	}
});

export const { setLocation } = locationSlice.actions;

export default locationSlice.reducer;
